<script setup lang="ts">
import useFormWriter from '~/composables/useFormWriter'
import FormWriterSkeleton from '~/components/skeletons/FormWriterSkeleton.vue'
import NotFound from '~/components/ResourceEngine/Components/NotFound.vue'
import FormWriter from '~/components/formwriter/FormWriter.vue'

const { locationId } = defineProps<{ locationId: number }>()

const { data, isLoadingFormData, isError } = useFormWriter(locationId)
</script>

<template>
  <NotFound v-if="isError" />
  <FormWriterSkeleton v-else-if="isLoadingFormData" />
  <FormWriter v-else-if="data" :item="data" />
</template>
